<template>
  <v-container fluid>
    <v-row style="height: 95vh !important;" align="center" justify="center">
      <v-col v-if="status === 'WAITING'">
        <p class="text-center">{{ $t('loading') }}</p>
      </v-col>
      <v-col v-else-if="status === 'ERROR'">
        <div class="d-flex align-center justify-center mb-5">
          <v-icon large>fa-exclamation-circle</v-icon>
        </div>
        <p class="text-center" v-html="$t('error')"/>
      </v-col>
      <v-col cols="12" sm="12" md="7" lg="5" xl="4" v-else>
        <v-card class="text-center px-5 py-7" outlined>
          <v-icon class="mb-5" :color="(allow)? 'primary' : 'gray'" large>{{ (allow)? 'fa-link' : 'fa-unlink' }}</v-icon>
          <h2 v-html="$t((allow)? 'done.allowed.title' : 'done.denied.title')"/>
          <p class="text-center" v-html="$t((allow)? 'done.allowed.subtitle' : 'done.denied.subtitle')"/>
          <v-btn @click="goToSwiset">{{ $t('btnGoToSwiset') }}</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Repository from '../../../repositories/auth';
export default {
  name: "SyncAuthorizationRequest",
  props: {
    key: Number,
    email: String,
    allow: Boolean
  },
  data() {
    return {
      status: 'WAITING',
    };
  },
  mounted() {
    this.verifyParams();
  },
  methods: {
    verifyParams() {
      if(this.key !== undefined && this.email !== undefined && this.allow !== undefined) {
        let syncResponse = {
          key: this.key,
          email: this.email,
          allow: this.allow,
        };

        // eslint-disable-next-line no-console
        console.log(this.allow);

        Repository.syncAuthorizationResponse(syncResponse).then((response) => {
          if(response.status < 400/* && response.data*/)
            this.status = 'DONE';
          else
            this.status = 'ERROR';
        });
      }
      else
        this.$router.push('/dashboard');
    },
    goToSwiset() {
      window.open(((screen.width >= 760))? 'https://onelink.to/97xuy6' : 'https://onelink.to/97xuy6');
    }
  }
}
</script>



<style scoped>

</style>
